import { Container } from '@mui/material'

import { LocaleText } from '@/components/LocaleText'
import { ProductCarousel } from '../ProductCarousel/ProductCarousel'

import type React from 'react'
import type { SxProps } from '@mui/material'
import type { ProductsList } from '@/gen/sanity/schema'
import type { ListContext } from '@/lib/eventBus/trackingEvents'

export const SanityProductsList: React.FC<{
  sanityComponent: ProductsList
  sx?: SxProps
}> = ({ sanityComponent, sx }) => {
  const listContext: ListContext = { kind: 'productRecommendations', sanityComponentId: `${sanityComponent?._id}` }

  const productsIds = sanityComponent.products?.map((id) => id.trim()).filter(Boolean)

  const numberOfProductsToShow = productsIds?.length ?? 0

  return (
    <Container disableGutters sx={sx}>
      <LocaleText {...sanityComponent.title} _type="localeText" typographyProps={{ variant: 'banner2' }} />
      {!!productsIds?.length && (
        <ProductCarousel
          productsIds={productsIds}
          listContext={listContext}
          numberOfProductsToShow={numberOfProductsToShow}
        />
      )}
    </Container>
  )
}
